import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

document.querySelectorAll<HTMLElement>('.header-hero-swiper').forEach((el) => {
    new Swiper(el, {
        modules: [Autoplay, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
    });
});
